// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"211eb7f9","455":"9470ec69","977":"3a4559c7"}[chunkId] + ".chunk.js";
};